<h3 translate class="text-center">TOP_PRODUCTS</h3>

@if (topProductListConfig.showDateRange) {
  <div class="d-flex gap-3 mb-3">
    <div>
      <label for="top-products-date-from" class="form-label small mb-1">{{ 'DATE_FROM' | translate }}</label>
      <input
        id="top-products-date-from"
        type="date"
        class="form-control form-control-sm"
        [value]="topProductListConfig.dateRange.value.from"
        (change)="setDateRange({ from: $any($event.target).value })"
      />
    </div>
    <div>
      <label for="top-products-date-to" class="form-label small mb-1">{{ 'DATE_TO' | translate }}</label>
      <input
        id="top-products-date-to"
        type="date"
        class="form-control form-control-sm"
        [value]="topProductListConfig.dateRange.value.to"
        (change)="setDateRange({ to: $any($event.target).value })"
      />
    </div>
  </div>
}

<lib-filter-list [configService]="topProductListConfig"></lib-filter-list>
